var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivePrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2D6CE6"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 8.723v-.038c-.01-.737-.301-1.429-.823-1.951-.53-.532-1.236-.824-1.986-.824H11.98C11.596 4.246 10.105 3.002 8.33 3L5.77 3C3.704 3 2.023 4.683 2.023 6.752v10.496C2.023 19.317 3.704 21 5.77 21h4.546c.518 0 .938-.42.938-.938s-.42-.938-.938-.938H5.77c-1.033 0-1.873-.842-1.873-1.876V6.752c0-1.035.84-1.876 1.872-1.876l2.56.001c1.033 0 1.873.842 1.873 1.876v.095c0 .518.42.938.937.938h8.051c.25 0 .486.097.663.274.17.17.266.394.273.634v.157c0 .482.392.873.874.873.552 0 1-.448 1-1v-.001z",
    transform: "translate(-371.000000, -216.000000) translate(355.000000, 208.000000) translate(16.000000, 8.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.297 14.922h-.422v-.985c0-.517-.42-.937-.938-.937-.517 0-.937.42-.937.938v1.921c0 .518.42.938.938.938h1.359c.518 0 .937-.42.937-.938 0-.517-.42-.937-.937-.937z",
    transform: "translate(-371.000000, -216.000000) translate(355.000000, 208.000000) translate(16.000000, 8.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.672 10C13.544 10 11 12.544 11 15.672c0 3.127 2.544 5.672 5.672 5.672 3.127 0 5.672-2.545 5.672-5.672 0-3.128-2.545-5.672-5.672-5.672zm0 9.469c-2.094 0-3.797-1.704-3.797-3.797 0-2.094 1.703-3.797 3.797-3.797 2.093 0 3.797 1.703 3.797 3.797 0 2.093-1.704 3.797-3.797 3.797z",
    transform: "translate(-371.000000, -216.000000) translate(355.000000, 208.000000) translate(16.000000, 8.000000)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivePrimary);
export default __webpack_public_path__ + "static/media/archive-primary.42cb3f2449c1f7a0725c0708e5fd35a2.svg";
export { ForwardRef as ReactComponent };